export default __webpack_public_path__ + "static/media/geran-de-klerk-WJkc3xZjSXw-unsplash.35b08104.webp";